'use client';

import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { AuthorDetails } from '../AuthorDetails/AuthorDetails';

export const PageContainer = styled(Container)`
    margin-bottom: ${getPurpurSpacing('1200')};
    ${purpurMedia('lg')`
        margin-bottom: ${getPurpurSpacing('1600')};
    `}
`;

export const SelectorWrapper = styled.div`
    margin-bottom: ${getPurpurSpacing('300')};
    ${purpurMedia('md')`
        display: flex;
        justify-content: flex-end;
        margin-bottom: ${getPurpurSpacing('400')};
    `}
`;

export const CardsListWrapper = styled.div`
    margin-top: ${getPurpurSpacing('800')};
    margin-bottom: ${getPurpurSpacing('1200')};

    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('1200')};
        margin-bottom: ${getPurpurSpacing('1600')};
    `}
`;

export const BlogAuthorDetails = styled(AuthorDetails)`
    margin-top: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('800')};

    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('1200')};
        margin-bottom: ${getPurpurSpacing('1200')};
        justify-content: center;
    `}
`;
